import PropTypes from 'prop-types';
import React from 'react';

//styles
import {BackgroundCircle, ForegroundCircle} from './styles';

const CircularProgressBar = ({className, containerSize = 32, radius = 12.8, strokeWidth = 1.28, style, value = 0}) => {
  const normalizedRadius = radius - strokeWidth * 2;
  const circumference = 2 * Math.PI * normalizedRadius;

  const strokeDasharray = `${circumference} ${circumference}`;
  const strokeDashoffset = circumference * (1 - value);

  const center = containerSize / 2;

  return (
    <svg
      className={className}
      data-cy-value={value}
      data-testid="CircularProgressBar"
      height={containerSize}
      style={style}
      width={containerSize}
    >
      <BackgroundCircle cx={center} cy={center} r={normalizedRadius} strokeWidth={strokeWidth} />
      <ForegroundCircle
        cx={center}
        cy={center}
        r={normalizedRadius}
        strokeDasharray={strokeDasharray}
        strokeWidth={strokeWidth}
        style={{strokeDashoffset}}
      />
    </svg>
  );
};

CircularProgressBar.propTypes = {
  className: PropTypes.string,
  containerSize: PropTypes.number,
  radius: PropTypes.number,
  strokeWidth: PropTypes.number,
  style: PropTypes.object,
  value: PropTypes.number
};

export default CircularProgressBar;
